module.exports = __webpack_public_path__ + "static/OneDotExt-Bold.33477e02.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt-Bold.woff
// module id = 748
// module chunks = 114276838955818